import axiosWrapper from './axiosWrapper'

const URL_LOGIN = `api/v1/portal/login`
const URL_LOGOUT = `api/v1/portal/logout`

function login(axiosParams, data) {
  const url = `${axiosParams.baseURL}/${URL_LOGIN}`
  return axiosWrapper.post({ ...axiosParams, url }, data)
}

const logout = (axiosParams) => {
  const url = `${axiosParams.baseURL}/${URL_LOGOUT}`
  return axiosWrapper.get({ ...axiosParams, url })
}

const autenticacion = {
  login,
  logout
}

export default autenticacion
